import * as React from 'react';
import { lazyInject } from '../services/inversify';
import { ApiService } from '../services/api_service';
import { WFormsTableWrapper } from '../core/table/WFormsTableWrapper';
import { IDs } from '../helpers/IDs';

interface EditUserProps extends React.ClassAttributes<any> {
    containerId?: string;
    data: any;
    onClose: () => void;
}

interface EditUserState extends React.ClassAttributes<any> {
}

export class EditUser extends React.Component<EditUserProps, EditUserState> {
    constructor(props: any) {
        super(props);
        this.state = {
        };

        this.userTid = this.apiService.getUserTid();
        this.isAdmin = this.apiService.isAdmin();
        this.isBerater = this.apiService.isBerater();
        this.isLoginOfMandantenUser = this.apiService.isLoginOfMandantenUser();

        this.onSaveDone = this.onSaveDone.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;

    private userTid: number;
    private isAdmin: boolean;
    private isBerater: boolean;
    private isLoginOfMandantenUser: boolean;

    render() {
        let params: any;
        if (this.isAdmin) {
            if (this.userTid > 0) {
                params = {
                    entity: IDs.ENT_USER,
                    module: IDs.MOD_LEGACY,
                    directEditFormularOf: { tid: this.userTid },
                    formGroupOrder: [{ fields: ['login', 'pass'] }],
                    customFormConfig: {
                        login: {
                            readonly: true
                        }
                    }
                }
            }
        } else if (this.isBerater) {
            if (this.userTid > 0) {
                params = {
                    entity: IDs.ENT_BERATER,
                    module: IDs.MOD_ETOOL_ADMIN,
                    directEditFormularOf: { tid: this.userTid },
                    formGroupOrder: [{ fields: ['mail', 'password'] }],
                    customFormConfig: {
                        mail: {
                            readonly: true
                        }
                    }
                }
            }
        } else if (this.isLoginOfMandantenUser) {
            if (this.userTid > 0) {
                params = {
                    entity: IDs.ENT_MANDANTEN_USER,
                    module: IDs.MOD_ETOOL_ADMIN,
                    directEditFormularOf: { tid: this.userTid },
                    formGroupOrder: [{ fields: ['mail', 'password'] }],
                    customFormConfig: {
                        mail: {
                            readonly: true
                        }
                    }
                }
            }
        } else {
            if (this.userTid > 0) {
                params = {
                    entity: IDs.ENT_REGISTRIERUNG,
                    module: IDs.MOD_ETOOL_ADMIN,
                    directEditFormularOf: { tid: this.userTid },
                    formGroupOrder: [{ fields: ['mail', 'password'] }],
                    customFormConfig: {
                        mail: {
                            readonly: true
                        }
                    }
                }
            }
        }

        if (params) {
            params = { ...params, customCssStyle: { outerStyle: { backgroundColor: 'white' } } };
            return this.renderForm(params);
        } else {
            return null;
        }
    }

    renderForm(params: any): JSX.Element {
        return <div>
            <WFormsTableWrapper
                containerId={this.props.containerId}
                formLayout='flowV2'
                customClass={'Custom-ETA'}
                formTitel={'Passwort ändern'}
                inlineFormular={true}
                validRestriction={'stop'}
                onAfterAction={(action: string) => {
                    if (action === 'saveDone') {
                        this.onSaveDone();
                    }
                    if (action === 'closeForm') {
                        this.props.onClose();
                    }
                }}
                {...params}
            />
        </div>;
    }

    onSaveDone() {
        alert('Ihr Passwort wurde erfolgreich geändert.');
    }
}
